import editor.keyboard.KeyboardManager
import ext.insertAsFirst
import kotlinx.browser.document
import org.w3c.dom.HTMLElement
import rendering.CameraManager
import rendering.ModelManager
import rendering.RendererManager
import util.WebViewBootstrap
import util.MouseManager
import util.StatsManager
import util.XRManager

/**
 * Main entry point of the application.
 *
 * 1. Load the models
 * 2. Find the current page
 * 3. Call the page's render method every frame
 */
suspend fun main() {
    WebViewBootstrap.markLoading(currentPage)

    try {
        CameraManager
        MouseManager
        XRManager
        KeyboardManager

        val loadingElt = loadingElement()
        ModelManager.tryLoadModels(loadingElt)
        currentPage.init()
        document.body?.removeChild(loadingElt)

        WebViewBootstrap.markReady(currentPage)

        var lastMillis = 0.0

        // main loop
        RendererManager.renderer.setAnimationLoop { currentMillis: Double ->
            StatsManager.begin()
            currentPage.render(currentMillis - lastMillis)
            lastMillis = currentMillis
            StatsManager.end()
        }
    } catch (t: Throwable) {
        WebViewBootstrap.markFailed(currentPage, t.message ?: t.toString())
        throw t
    }
}

private fun loadingElement() = document.body!!.insertAsFirst(
    (document.createElement("div") as HTMLElement).apply {
        style.apply {
            color = "white"
            position = "fixed"
            fontSize = "2em"
            margin = "16px"
            fontFamily = "MunkenSansWeb-Bold, sans-serif"
            top = "50%"
            left = "50%"
            transform = "translate(-50%, -50%)"
        }
        innerHTML = "Lädt..."
    },
)
